import { Link } from "react-router-dom";
import { articles } from "@/mocks/articlesData";

export default function LatestUpdates() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            <a href="#latest">最新资讯</a>
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            动漫资讯、深度分析、新番推荐
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all cursor-pointer"
          >
            <div className="aspect-[16/9] overflow-hidden bg-background-200">
              <img
                src={article.cover}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60">
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {article.readCount}
                </span>
                <span className="text-xs text-foreground-400">
                  <i className="ri-user-line mr-1"></i>
                  {article.author}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}